import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CurrentTermsType } from "api/types";
import ThreeDots from "components/common/Loader/ThreeDots";
import Modal from "components/common/Modal/Modal";
import React, { FunctionComponent } from "react";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import { CloseButton, ScrollableText } from "./TermsAndConditions.style";
interface IProps {
  isOpen: boolean;
  currentTermsType?: CurrentTermsType;
  onRequestClose();
}

function createMarkup(html: string) {
  return { __html: html };
}

const TermsAndConditionsModal: FunctionComponent<IProps> = ({
  isOpen,
  currentTermsType,
  onRequestClose
}) => {
  const { getTcpaDetails } = OnboardingContainer.useContainer();
  const { tcpaDetails, loadingTcpaDetails } = getTcpaDetails();
  return (
    <Modal
      large
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      maxHeight="70vh"
      maxWidth="75vw"
      smallPadding
    >
      <CloseButton onClick={onRequestClose}>
        <FontAwesomeIcon icon="times" size="2x" />
      </CloseButton>
      <ScrollableText>
        {loadingTcpaDetails ? (
          <div style={{ textAlign: "center", marginTop: "3rem" }}>
            <ThreeDots />
          </div>
        ) : (
          tcpaDetails &&
          currentTermsType && (
            <div
              dangerouslySetInnerHTML={createMarkup(
                tcpaDetails[currentTermsType]
              )}
            />
          )
        )}
      </ScrollableText>
    </Modal>
  );
};

export default TermsAndConditionsModal;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/WelcomeBoard/TermsAndConditions/TermsAndConditionsModal.tsx